import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import GuaranteeForm from "@/pages/GuaranteeForm";
import SuccessPage from "@/pages/SuccessPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import LetterDetail from "@/pages/LetterDetail";
import AdminVisaTypes from "@/pages/AdminVisaTypes";

function App() {
  return (
    <div className="App min-h-screen bg-background">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/form" element={<GuaranteeForm />} />
          <Route path="/success/:letterId" element={<SuccessPage />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/letter/:letterId" element={<LetterDetail />} />
          <Route path="/admin/visa-types" element={<AdminVisaTypes />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
